import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Board, Close } from "@air/next-icons";
import { IconButton } from "@air/primitive-icon-button";
import { memo } from "react";
import { useSelector } from "react-redux";
import { EditableAssetModalTitle } from "~/components/AssetModal/components/EditableAssetModalTitle";
import { validateAssetTitle } from "~/components/AssetModal/Header/components/EditableAssetModalHeaderTitle";
import { ASSET_TITLE } from "~/constants/testIDs";
import { centralizedClipBoardInfoSelector, CentralizedClipSelectors } from "~/store/centralizedClip/selectors";
export const MobileHeader = /*#__PURE__*/ memo((param)=>{
    let { onClose, onUpdateTitle } = param;
    const title = useSelector(CentralizedClipSelectors.displayTitle);
    const { current, others } = useSelector(centralizedClipBoardInfoSelector);
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex h-[80px] w-full shrink-0 items-center justify-start bg-grey-1 p-3",
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: "flex h-full flex-col justify-center gap-1 px-3",
                children: [
                    !!onUpdateTitle ? /*#__PURE__*/ _jsx("div", {
                        className: "-ml-2.5 flex",
                        children: /*#__PURE__*/ _jsx(EditableAssetModalTitle, {
                            className: "grow-0",
                            defaultValue: title,
                            onSubmit: onUpdateTitle,
                            validate: validateAssetTitle
                        })
                    }) : /*#__PURE__*/ _jsx("h1", {
                        className: "flex h-9 w-full shrink-0 items-center truncate text-18 font-semibold text-grey-11",
                        "data-testid": ASSET_TITLE,
                        children: title
                    }),
                    (!!current || !!others.length) && /*#__PURE__*/ _jsxs("div", {
                        className: "flex items-center justify-start",
                        children: [
                            !!current && /*#__PURE__*/ _jsxs("div", {
                                className: "text-14 text-grey-11",
                                children: [
                                    "in",
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "ml-1 font-medium text-grey-12",
                                        children: current.title
                                    })
                                ]
                            }),
                            !!others.length && /*#__PURE__*/ _jsxs(_Fragment, {
                                children: [
                                    !!current && /*#__PURE__*/ _jsx("div", {
                                        className: "text-14 text-grey-12",
                                        children: "・"
                                    }),
                                    /*#__PURE__*/ _jsx(Board, {
                                        className: "size-4 text-grey-12"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "ml-1 text-14 font-medium text-grey-11",
                                        children: others.length
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            !!onClose && /*#__PURE__*/ _jsx(IconButton, {
                icon: Close,
                appearance: "ghost",
                color: "grey",
                size: "extra-large",
                onClick: onClose,
                className: "ml-auto",
                label: "Close modal"
            })
        ]
    });
});
MobileHeader.displayName = "MobileHeader";
